import { IconSVG } from '../types';

export const PhysicalTherapy = ({ size, style }: IconSVG) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={size}
    height={size}
    style={style} 
    fill="none" 
    viewBox="0 0 74 74">
    <path
      fill="currentColor"
      d="m43.932 67.02-14.4-5.639H12.618q-1.296 0-2.171-.876-.877-.876-.877-2.171V49.19q0-6.324 4.458-10.781 4.456-4.457 10.78-4.457h32.686q2.895 0 4.914 1.98 2.02 1.982 2.02 4.877a6.72 6.72 0 0 1-1.448 4.228q-1.447 1.867-3.657 2.477l-7.086 2.057v11.81q0 1.599-.724 2.895a6.26 6.26 0 0 1-1.943 2.133 6.04 6.04 0 0 1-2.666 1.029q-1.448.19-2.972-.42M29 52.238q-.534 0-.8.304a1.46 1.46 0 0 0-.343.686 1.03 1.03 0 0 0 .114.724q.19.342.648.495l17.524 6.933V52.24zm-13.333 3.047h6.4a6 6 0 0 1-.229-.914 6 6 0 0 1-.076-.99q0-2.973 2.133-5.105 2.133-2.134 5.105-2.134h12.419l16.305-4.495q.38-.153.533-.381a.64.64 0 0 0 .076-.533 1.04 1.04 0 0 0-.267-.495q-.19-.19-.57-.191H24.807q-3.81 0-6.476 2.667t-2.666 6.476zm15.238-24.38q-5.03 0-8.61-3.582-3.58-3.58-3.58-8.61 0-5.028 3.58-8.609 3.58-3.58 8.61-3.58 5.028 0 8.61 3.58 3.58 3.58 3.58 8.61 0 5.028-3.58 8.61-3.582 3.58-8.61 3.58m0-6.096q2.514 0 4.304-1.79 1.79-1.792 1.79-4.305 0-2.515-1.79-4.305t-4.304-1.79-4.305 1.79q-1.79 1.79-1.79 4.305 0 2.513 1.79 4.304 1.79 1.79 4.305 1.79"
     />
  </svg>
);

export default PhysicalTherapy;